import React from 'react';
import createInlineStyleButton from './util/createInlineStyleButton';

export default createInlineStyleButton({
  style: 'SUBSCRIPT',
  children: (
    <i className="fa fa-subscript" aria-hidden="true"></i>
  ),
});
